import React from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

function Footer() {
  return (
    <MDBFooter
      color="unique-color-dark"
      className="page-footer  font-small pt-0"
    >
      <div>
        <MDBContainer fluid className="text-center text-md-left">
          <MDBRow className="py-4 d-flex align-items-center">
            <MDBCol
              md="12"
              lg="12"
              className="text-center text-md-left mb-4 mb-md-0"
            >
              <p className="mb-0 white-text" style={{ "font-size": "1rem" }}>
                This site was built by the Laboratory of Neurobiology at
                Northeastern University. <br></br>© Günther K. H. Zupanc (2020).
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </MDBFooter>
  );
}

export default Footer;
